/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard PRO React base styles
import borders from "assets/theme/base/borders";
import AddBalance from '../AddBalance'
// Images
import masterCardLogo from "assets/images/logos/mastercard.png";
import visaLogo from "assets/images/logos/visa.png";
import SoftSelect from "components/SoftSelect";
import "./index.css";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useAgencyStripeCard } from "queries/billing";
import { useUpdateAgency } from "queries/agency";
import { useAgencyInfo } from "context/agency";
function PaymentMethod() {
  const { borderWidth, borderColor } = borders;
  const [agency, Update] = useAgencyInfo();

  // "agency-stripe" is the shared resource name for the agency's AI-wallet
  // payment method - components/Subscriptionodal/AddCardModal invalidates
  // this same key after creating/updating the card on file.
  const { data: agencyStripe, refetch: getAgencyStripe } = useAgencyStripeCard(agency?._id);

  const prices = [
    "10",
    "25",
    "100",
    "500",
    "1000",
    "5000",
  ]

  const updateAgencyMutation = useUpdateAgency(true);

  const handleAutoCharge = async (e) => {
    const payload = {
      auto_charge: e.value,
      _id: agency._id,
    };

    const { response } = await updateAgencyMutation.mutateAsync(payload);
    if (response) {
      Update(response.data);
    }
  }
  const handleLowBalance = async (e) => {
    const payload = {
      low_balancs_limit: e.value,
      _id: agency._id,
    };

    const { response } = await updateAgencyMutation.mutateAsync(payload);
    if (response) {
      Update(response.data);
    }
  }
  return (
    <div className="w-100" id="delete-account">
      <h1 className="text-black text-bold" style={{ margin: "20px 0px 20px 20px" }}>AI Wallet</h1>

      <div className="bg-card bg-white d-flex justify-content-between p-2 border-agust" style={{ padding: "50px", margin: "10px 11px" }}>
        <div className="w-50">
          <h3 className="text-black text-bold font-16">Your Balance</h3>
          <p className="inter-family text-black text-bold" style={{ fontSize: "30px", padding: "0px 0px 12px 0px" }}>
            ${agency.Balance ? parseFloat(agency.Balance).toFixed(2) : "0.00"}</p>
          <AddBalance agencyStripe={agencyStripe} handleRefresh={getAgencyStripe} />
        </div>
        <div className="w-50">
          <div style={{ margin: "55px 0px 0px 0px" }} className="d-flex justify-content-between">
            <div style={{ marginBottom: '10px' }}>
              <p className="font-16 text-bold mb-5"> Auto recharge with :</p>
            </div>
          </div>

          <div className="d-flex justify-content-between" >
            <div>
              <SoftSelect
                sx={{ width: "200px" }} // Increase the width here
                onChange={(e) => handleAutoCharge(e)}
                placeholder="Select Default Plan.."
                defaultValue={{ value: agency?.auto_charge, label: "$" + agency?.auto_charge }}
                // defaultValue={{ value: agency?.default_plan?.split("-")[0], label: agency?.default_plan?.split("-")[1] }}
                options={prices.map((price) => ({
                  label: "$" + price,
                  value: price,
                }))}
                className="inter-family"
              />
            </div>
            <div className="w-100 margin-x-10px d-flex">
              <p className="font-16 text-bold" style={{ margin: "10px 10px 0px 0px" }}> When Balance is lower than </p>
              <SoftSelect
                sx={{ width: "10px" }}
                onChange={(e) => handleLowBalance(e)}
                placeholder="Select Default Plan.."
                className="inter-family"
                defaultValue={{ value: agency?.low_balancs_limit, label: "$" + agency?.low_balancs_limit }}
                options={prices.map((price) => ({
                  label: "$" + price,
                  value: price,
                }))}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentMethod;
